// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#texture-editor {
  height: 100%;
  width: 100%;
  color: white;
  background-color: #1e1e1e;
  font-family: "acumin-pro-condensed";
}
#texture-editor .icon {
  width: 40px;
  height: 40px;
}
#texture-editor .icon.button {
  background-color: #333333;
}
#texture-editor .icon.button:hover {
  background-color: #4a4a4a;
  cursor: pointer;
}
#texture-editor .icon.button.active {
  background-color: #666666;
}
#texture-editor .icon.button:active {
  background-color: #837c7c;
}
#texture-editor .has-tooltip {
  display: inline-block;
}
#texture-editor .has-tooltip .tooltip {
  visibility: hidden;
  background-color: rgb(255, 255, 255);
  z-index: 1;
  position: absolute;
  opacity: 0;
  transition: opacity 0.5s;
  line-height: normal;
  font-size: 14px;
  padding: 0px 5px;
  color: black;
}
#texture-editor .has-tooltip:hover .tooltip {
  visibility: visible;
  opacity: 1;
}
#texture-editor #properties {
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  font-size: 12px;
  color: white;
  user-select: none;
  background-color: #333333;
}
#texture-editor #properties .tab {
  display: inline-flex;
  line-height: 40px;
  height: 40px;
  flex-shrink: 0;
  flex-grow: 0;
  border-right: 2px solid #1e1e1e;
  background-color: #333333;
}
#texture-editor #properties #left {
  overflow: hidden;
  height: 40px;
  flex-grow: 1;
  flex-shrink: 1;
  display: flex;
  flex-wrap: wrap;
}
#texture-editor #properties #left #dimensions-tab form {
  display: flex;
}
#texture-editor #properties #left #dimensions-tab label {
  margin-left: 15px;
  font-size: 15px;
  color: #afafaf;
}
#texture-editor #properties #left #dimensions-tab label input {
  width: 40px;
  height: 24px;
  background-color: #000000;
  color: #ffffff;
  border: 0;
  font-size: 12px;
  text-align: "left";
  font-family: "acumin-pro-condensed";
  font-size: 15px;
  padding-left: 8px;
}
#texture-editor #properties #left #dimensions-tab label:last-of-type {
  margin-right: 8px;
}
#texture-editor #properties #right-tab {
  margin-right: 0;
  flex-grow: 0;
  flex-shrink: 0;
}
#texture-editor #properties #right-tab input[type=file] {
  display: none;
}
#texture-editor #properties .pixel-data {
  width: 45px;
  color: #afafaf;
  display: flex;
  justify-content: space-between;
  font-size: 15px;
}
#texture-editor #properties .pixel-data:first-of-type {
  margin-left: 15px;
}
#texture-editor #properties .pixel-data:last-of-type {
  padding-right: 15px;
}
#texture-editor #properties .pixel-data .value {
  display: inline-block;
  width: 30px;
  color: white;
}
#texture-editor #toolbar {
  position: absolute;
  top: 60px;
  left: 0;
  width: 40px;
  display: flex;
  flex-direction: column;
  justify-content: left;
}
#texture-editor #toolbar #tools {
  display: flex;
  flex-direction: column;
}
#texture-editor #toolbar #add-tool {
  position: relative;
}
#texture-editor #toolbar #add-tool #add-tool-popup {
  background-color: #333333;
  width: 348px;
  margin-left: 40px;
  position: absolute;
  top: 0px;
  height: 40px;
  padding-left: 4px;
  line-height: 40px;
  user-select: none;
}
#texture-editor #toolbar #add-tool #add-tool-popup button {
  background: #222222;
  border: 1px solid rgb(51, 122, 183);
  margin: 5px 10px 5px 10px;
  color: white;
  padding: 4px 5px;
  opacity: 0.9;
  cursor: pointer;
}
#texture-editor #toolbar #color {
  margin-top: 8px;
}
#texture-editor #toolbar #color #active-color-bg {
  border-radius: 50%;
  width: 20px;
  height: 20px;
  margin: 10px;
  position: relative;
  background-image: linear-gradient(45deg, #808080 25%, transparent 25%), linear-gradient(-45deg, #808080 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #808080 75%), linear-gradient(-45deg, transparent 75%, #808080 75%);
  background-size: 20px 20px;
  background-position: 0 0, 0 10px, 10px -10px, -10px 0px;
}
#texture-editor #toolbar #color #active-color {
  width: 20px;
  height: 20px;
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 50%;
}
#texture-editor #toolbar #color-picker {
  position: absolute;
  margin-left: 40px;
}
#texture-editor #channels-bar {
  position: absolute;
  top: 60px;
  right: 0;
  width: 80px;
  background: #666666;
  user-select: none;
}
#texture-editor #channels-bar .channel {
  color: white;
  border-bottom: 2px solid #232323;
  width: 80px;
  height: 40px;
  font-size: 16px;
  display: flex;
  align-items: center;
}
#texture-editor #channels-bar .channel.uneditable {
  background: #333333;
}
#texture-editor #channels-bar .channel:hover {
  cursor: pointer;
}
#texture-editor #channels-bar .channel:last-of-type {
  border-bottom: none;
}
#texture-editor #canvas-ui {
  width: 100%;
  height: calc(100% - 70px);
  outline: none;
}
#texture-editor #tool-ui {
  background-color: #333;
  position: absolute;
  right: 0;
  bottom: 30px;
}
#texture-editor #tool-ui label {
  display: flex;
  flex-direction: column;
  align-items: center;
}
#texture-editor #tool-ui input[type=range] {
  background: #d3d3d3;
}
#texture-editor #bottom-bar {
  height: 30px;
  width: 100%;
  background-color: #333333;
  font-size: 14px;
  user-select: none;
  line-height: 30px;
  position: relative;
}
#texture-editor #bottom-bar #file-url {
  left: 30px;
  position: absolute;
}
#texture-editor #bottom-bar #mip-level {
  right: 30px;
  position: absolute;
}`, "",{"version":3,"sources":["webpack://./../../../dev/inspector/dist/components/actionTabs/tabs/propertyGrids/materials/textures/textureEditor.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mCAAA;AACJ;AACI;EACI,WAAA;EACA,YAAA;AACR;AAAQ;EACI,yBAAA;AAEZ;AADY;EACI,yBAAA;EACA,eAAA;AAGhB;AAAY;EACI,yBAAA;AAEhB;AACY;EACI,yBAAA;AAChB;AAII;EACI,qBAAA;AAFR;AAGQ;EACI,kBAAA;EACA,oCAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EACA,wBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;AADZ;AAIQ;EACI,mBAAA;EACA,UAAA;AAFZ;AAMI;EACI,WAAA;EACA,YAAA;EAEA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,yBAAA;AALR;AAOQ;EACI,oBAAA;EACA,iBAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,+BAAA;EACA,yBAAA;AALZ;AAOQ;EACI,gBAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;AALZ;AAOgB;EACI,aAAA;AALpB;AAOgB;EACI,iBAAA;EACA,eAAA;EACA,cAAA;AALpB;AAMoB;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,cAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;EACA,mCAAA;EACA,eAAA;EACA,iBAAA;AAJxB;AAOoB;EACI,iBAAA;AALxB;AAUQ;EACI,eAAA;EACA,YAAA;EACA,cAAA;AARZ;AAUY;EACI,aAAA;AARhB;AAYQ;EAOI,WAAA;EACA,cAAA;EACA,aAAA;EACA,8BAAA;EAMA,eAAA;AArBZ;AAMY;EACI,iBAAA;AAJhB;AAMY;EACI,mBAAA;AAJhB;AAUY;EACI,qBAAA;EACA,WAAA;EACA,YAAA;AARhB;AAcI;EACI,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;AAZR;AAcQ;EACI,aAAA;EACA,sBAAA;AAZZ;AAeQ;EACI,kBAAA;AAbZ;AAcY;EACI,yBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;AAZhB;AAagB;EACI,mBAAA;EACA,mCAAA;EACA,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;AAXpB;AAgBQ;EACI,eAAA;AAdZ;AAeY;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,0OAAA;EAEA,0BAAA;EACA,uDACI;AAfpB;AAoBY;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,kBAAA;AAlBhB;AAqBQ;EACI,kBAAA;EACA,iBAAA;AAnBZ;AAuBI;EACI,kBAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,mBAAA;EAsBA,iBAAA;AA1CR;AAqBQ;EACI,YAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;AAnBZ;AAqBY;EACI,mBAAA;AAnBhB;AAsBY;EACI,eAAA;AApBhB;AAuBY;EACI,mBAAA;AArBhB;AA2BI;EACI,WAAA;EACA,yBAAA;EACA,aAAA;AAzBR;AA4BI;EACI,sBAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA;AA1BR;AA4BQ;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;AA1BZ;AA6BQ;EACI,mBAAA;AA3BZ;AA+BI;EACI,YAAA;EACA,WAAA;EACA,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;AA7BR;AA8BQ;EACI,UAAA;EACA,kBAAA;AA5BZ;AA8BQ;EACI,WAAA;EACA,kBAAA;AA5BZ","sourcesContent":["#texture-editor {\r\n    height: 100%;\r\n    width: 100%;\r\n    color: white;\r\n    background-color: #1e1e1e;\r\n    font-family: \"acumin-pro-condensed\";\r\n\r\n    .icon {\r\n        width: 40px;\r\n        height: 40px;\r\n        &.button {\r\n            background-color: #333333;\r\n            &:hover {\r\n                background-color: #4a4a4a;\r\n                cursor: pointer;\r\n            }\r\n            // When the button is selected - className='active'\r\n            &.active {\r\n                background-color: #666666;\r\n            }\r\n            // When the button is clicked\r\n            &:active {\r\n                background-color: #837c7c;\r\n            }\r\n        }\r\n    }\r\n\r\n    .has-tooltip {\r\n        display: inline-block;\r\n        .tooltip {\r\n            visibility: hidden;\r\n            background-color: rgb(255, 255, 255);\r\n            z-index: 1;\r\n            position: absolute;\r\n            opacity: 0;\r\n            transition: opacity 0.5s;\r\n            line-height: normal;\r\n            font-size: 14px;\r\n            padding: 0px 5px;\r\n            color: black;\r\n        }\r\n\r\n        &:hover .tooltip {\r\n            visibility: visible;\r\n            opacity: 1;\r\n        }\r\n    }\r\n\r\n    #properties {\r\n        width: 100%;\r\n        height: 40px;\r\n\r\n        display: flex;\r\n        align-items: center;\r\n        font-size: 12px;\r\n        color: white;\r\n        user-select: none;\r\n        background-color: #333333;\r\n\r\n        .tab {\r\n            display: inline-flex;\r\n            line-height: 40px;\r\n            height: 40px;\r\n            flex-shrink: 0;\r\n            flex-grow: 0;\r\n            border-right: 2px solid #1e1e1e;\r\n            background-color: #333333;\r\n        }\r\n        #left {\r\n            overflow: hidden;\r\n            height: 40px;\r\n            flex-grow: 1;\r\n            flex-shrink: 1;\r\n            display: flex;\r\n            flex-wrap: wrap;\r\n            #dimensions-tab {\r\n                form {\r\n                    display: flex;\r\n                }\r\n                label {\r\n                    margin-left: 15px;\r\n                    font-size: 15px;\r\n                    color: #afafaf;\r\n                    input {\r\n                        width: 40px;\r\n                        height: 24px;\r\n                        background-color: #000000;\r\n                        color: #ffffff;\r\n                        border: 0;\r\n                        font-size: 12px;\r\n                        text-align: \"left\";\r\n                        font-family: \"acumin-pro-condensed\";\r\n                        font-size: 15px;\r\n                        padding-left: 8px;\r\n                    }\r\n\r\n                    &:last-of-type {\r\n                        margin-right: 8px;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n        #right-tab {\r\n            margin-right: 0;\r\n            flex-grow: 0;\r\n            flex-shrink: 0;\r\n\r\n            input[type=\"file\"] {\r\n                display: none;\r\n            }\r\n        }\r\n\r\n        .pixel-data {\r\n            &:first-of-type {\r\n                margin-left: 15px;\r\n            }\r\n            &:last-of-type {\r\n                padding-right: 15px;\r\n            }\r\n            width: 45px;\r\n            color: #afafaf;\r\n            display: flex;\r\n            justify-content: space-between;\r\n            .value {\r\n                display: inline-block;\r\n                width: 30px;\r\n                color: white;\r\n            }\r\n            font-size: 15px;\r\n        }\r\n    }\r\n\r\n    #toolbar {\r\n        position: absolute;\r\n        top: 60px;\r\n        left: 0;\r\n        width: 40px;\r\n        display: flex;\r\n        flex-direction: column;\r\n        justify-content: left;\r\n\r\n        #tools {\r\n            display: flex;\r\n            flex-direction: column;\r\n        }\r\n\r\n        #add-tool {\r\n            position: relative;\r\n            #add-tool-popup {\r\n                background-color: #333333;\r\n                width: 348px;\r\n                margin-left: 40px;\r\n                position: absolute;\r\n                top: 0px;\r\n                height: 40px;\r\n                padding-left: 4px;\r\n                line-height: 40px;\r\n                user-select: none;\r\n                button {\r\n                    background: #222222;\r\n                    border: 1px solid rgb(51, 122, 183);\r\n                    margin: 5px 10px 5px 10px;\r\n                    color: white;\r\n                    padding: 4px 5px;\r\n                    opacity: 0.9;\r\n                    cursor: pointer;\r\n                }\r\n            }\r\n        }\r\n\r\n        #color {\r\n            margin-top: 8px;\r\n            #active-color-bg {\r\n                border-radius: 50%;\r\n                width: 20px;\r\n                height: 20px;\r\n                margin: 10px;\r\n                position: relative;\r\n                background-image: linear-gradient(45deg, #808080 25%, transparent 25%), linear-gradient(-45deg, #808080 25%, transparent 25%),\r\n                    linear-gradient(45deg, transparent 75%, #808080 75%), linear-gradient(-45deg, transparent 75%, #808080 75%);\r\n                background-size: 20px 20px;\r\n                background-position:\r\n                    0 0,\r\n                    0 10px,\r\n                    10px -10px,\r\n                    -10px 0px;\r\n            }\r\n            #active-color {\r\n                width: 20px;\r\n                height: 20px;\r\n                position: absolute;\r\n                top: 0;\r\n                left: 0;\r\n                border-radius: 50%;\r\n            }\r\n        }\r\n        #color-picker {\r\n            position: absolute;\r\n            margin-left: 40px;\r\n        }\r\n    }\r\n\r\n    #channels-bar {\r\n        position: absolute;\r\n        top: 60px;\r\n        right: 0;\r\n        width: 80px;\r\n        background: #666666;\r\n        .channel {\r\n            color: white;\r\n            border-bottom: 2px solid #232323;\r\n            width: 80px;\r\n            height: 40px;\r\n            font-size: 16px;\r\n            display: flex;\r\n            align-items: center;\r\n\r\n            &.uneditable {\r\n                background: #333333;\r\n            }\r\n\r\n            &:hover {\r\n                cursor: pointer;\r\n            }\r\n\r\n            &:last-of-type {\r\n                border-bottom: none;\r\n            }\r\n        }\r\n        user-select: none;\r\n    }\r\n\r\n    #canvas-ui {\r\n        width: 100%;\r\n        height: calc(100% - 70px);\r\n        outline: none;\r\n    }\r\n\r\n    #tool-ui {\r\n        background-color: #333;\r\n        position: absolute;\r\n        right: 0;\r\n        bottom: 30px;\r\n\r\n        label {\r\n            display: flex;\r\n            flex-direction: column;\r\n            align-items: center;\r\n        }\r\n\r\n        input[type=\"range\"] {\r\n            background: #d3d3d3;\r\n        }\r\n    }\r\n\r\n    #bottom-bar {\r\n        height: 30px;\r\n        width: 100%;\r\n        background-color: #333333;\r\n        font-size: 14px;\r\n        user-select: none;\r\n        line-height: 30px;\r\n        position: relative;\r\n        #file-url {\r\n            left: 30px;\r\n            position: absolute;\r\n        }\r\n        #mip-level {\r\n            right: 30px;\r\n            position: absolute;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
